module.exports = __webpack_public_path__ + "static/media/harbor_seals.20489fef.jpg";